import { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import Loader from "../../Global/Loader";
import cdpService from "../../../apiService/cdp.service";

const DeviceChart = () => {
    const [deviceData, setDeviceData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        cdpService.getDeviceGraph()
            .then((response) => response.data)
            .then((data) => {
                if (data.success && data.data.deviceData) {
                    const formattedData = [
                        ["Element", "Device Base Sign-Ups", { role: "annotation" }, { role: "style" }],
                        ["M-Web", data.data.deviceData.mwebPercent, `${data.data.deviceData.mwebPercent}% (${data.data.deviceData.mwebCount})`, "#2c95ec"],
                        ["Desktop", data.data.deviceData.webPercent, `${data.data.deviceData.webPercent}% (${data.data.deviceData.webCount})`, "#f64d2a"],
                        ["App", data.data.deviceData.appPercent, `${data.data.deviceData.appPercent}% (${data.data.deviceData.appCount})`, "#f6ba2a"],
                    ];
                    setDeviceData(formattedData);
                }
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, []);

    const options = {
        title: "Platform Base Sign-Ups",
        bar: { groupWidth: "60%" },
        legend: { position: "none" },
        format:'decimal',
        chartArea: {
            left: 10,
            right: 10,
            bottom: 20,
            top: 20,
            width: "100%",
            height: "100%",
        },
    };

    if (loading) return <Loader/>;
    if (error) return <p>Error loading chart data.</p>;

    return <Chart chartType="BarChart" width="100%" height="250px" data={deviceData} options={options} />;
};

export default DeviceChart;
